import { render, staticRenderFns } from "./JiyunIndication.vue?vue&type=template&id=37144f1d&scoped=true"
import script from "./JiyunIndication.vue?vue&type=script&lang=js"
export * from "./JiyunIndication.vue?vue&type=script&lang=js"
import style0 from "./JiyunIndication.vue?vue&type=style&index=0&id=37144f1d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37144f1d",
  null
  
)

export default component.exports